import lang from "@/views/modules/Applications/language/en";

let metaList = [
   /*  {
        label: lang.LBL_APPLICATION_NO,
        link: true,
        columnName: 'app_no',
        width:150,
    }, */
    {
        label: lang.LBL_APPLICATION_TITLE,
        link: true,
        columnName: 'application_title',
    },
    {
        label: lang.LBL_SCHEME_TYPE,
        link: false,
        columnName: 'opportunity_type',
    },
    {
        label: lang.LBL_FUNDER,
        link: false,
        columnName: 'opportunity_funder',
    },
    {
        label: lang.LBL_APPLICATION_BY,
        link: false,
        columnName: 'created_by',
    },
    /*{
        label: lang.LBL_OPPORTUNITY_BY,
        link: false,
        columnName: 'op_created_by',
    },*/
    {
        label: lang.LBL_STAGE,
        link: false,
        columnName: 'status',
    },
];
const link_list = {
    routePath: 'applications',
    title: 'Recent Active Applications',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }